import { render } from "./IndexOverview.vue?vue&type=template&id=705d6612"
import script from "./IndexOverview.vue?vue&type=script&lang=js"
export * from "./IndexOverview.vue?vue&type=script&lang=js"

import "./IndexOverview.vue?vue&type=style&index=0&id=705d6612&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__